module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_mattrz_social-a63a477881c88a21c694ed9711c7204d.svg";